import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/main/Main'
import Home from '@/components/main/Home'
import About from '@/components/main/About'
import Class from '@/components/main/Class'
import News from '@/components/main/News'
import Partner from '@/components/main/Partner'
import TeachingUsage from '@/components/main/TeachingUsage'
import Product from '@/components/main/Product'
import address from '@/components/account/address'
import MyPoints from '@/components/account/MyPoints'
import Login from '@/components/account/Login'
import Invite from '@/components/account/Invite'
import Bind from '@/components/account/Bind'
import Signup from '@/components/account/Signup'
import ResetPassword from '@/components/account/ResetPassword'
import SetPassword from '@/components/account/SetPassword'
import Contact from '@/components/account/Contact'
import GetCode from '@/components/GetCode'
import addPrescriptionContact from '@/components/kaifang/addPrescriptionContact'
import prescriptionInfo from '@/components/kaifang/prescriptionInfo'
import prescriptionResult from '@/components/kaifang/prescriptionResult'
import Prescription from '@/components/kaifang/Prescription'
import GeneralPrescriptionInfo from '@/components/GeneralFormula/prescriptionInfo'
import GeneralPrescriptionResult from '@/components/GeneralFormula/prescriptionResult'
import GeneralPrescription from '@/components/GeneralFormula/Prescription'
import addServiceContact from '@/components/addServiceContact.vue'
import serviceResult from '@/components/serviceResult'
import prescriptionImage from '@/components/kaifang/prescriptionImage.vue'
import order from '@/components/account/order'
import apply from '@/components/account/apply'
import applying from '@/components/account/applying'
import userInfo from '@/components/account/userInfo'
import AboutUsers from '@/components/AboutUsers'
import fulfillmentConfirm from '@/components/fulfillment/fulfillmentConfirm'
import fulfillmentOrder from '@/components/fulfillment/fulfillmentOrder'
import wjtpay from '@/components/pay/wjtpay'
import protocol from '@/components/account/protocol'

import handmadePrescription from '@/components/kaifang/handmadePrescription'
import handmadePrescriptionConfirm from '@/components/kaifang/handmadePrescriptionConfirm'
import handmadePrescriptionDetails from '@/components/kaifang/handmadePrescriptionDetails'

import CUSTOMIZEDPrescription from '@/components/CUSTOMIZED/Prescription'
import CUSTOMIZEDfulfillmentConfirm from '@/components/CUSTOMIZED/fulfillmentConfirm'
import CUSTOMIZEDfulfillmentOrder from '@/components/CUSTOMIZED/fulfillmentOrder'

import commonAddPrescriptionContact from '@/components/common/addPrescriptionContact'
import commonPrescriptionInfo from '@/components/common/prescriptionInfo'
import commonHandmadePrescription from '@/components/common/handmadePrescription'
import commonHandmadePrescriptionConfirm from '@/components/common/handmadePrescriptionConfirm'

import commonHandmadePrescriptionDetails from '@/components/common/handmadePrescriptionDetails'
import commonPrescriptionImage from '@/components/common/prescriptionImage'
import commonFulfillmentConfirm from '@/components/common/fulfillmentConfirm'
import chaoweiAddPrescriptionContact from '@/components/chaowei/addPrescriptionContact'
import chaoweiPrescriptionInfo from '@/components/chaowei/prescriptionInfo'
import chaoweiPrescriptionResult from '@/components/chaowei/prescriptionResult'
import ChaoWeiPrescription from '@/components/chaowei/Prescription'
import chaoweiPrescriptionImage from '@/components/chaowei/prescriptionImage'




Vue.use(Router)


const router = new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      component: Main,
      children:[
        {
          path: '/',
          name: 'Home',
          component: Home,
          meta:{
            title:'百草元和'
          }
        },
        {
          path: '/Product',
          name: 'Product',
          component: Product,
          meta:{
            title:'百草产品'
          }
        },
        {
          path: '/About',
          name: 'About',
          component: About,
          meta:{
            title:'关于百草'
          }
        },
        {
          path: '/Class',
          name: 'Class',
          component: Class,
          meta:{
            title:'百草课堂'
          }
        },
        {
          path: '/News',
          name: 'News',
          component: News,
          meta:{
            title:'百草新闻'
          }
        },
        {
          path: '/TeachingUsage',
          name: 'TeachingUsage',
          component: TeachingUsage,
          meta:{
            title:'使用教学'
          }
        },
        {
          path: '/Partner',
          name: 'Partner',
          component: Partner,
          meta:{
            title:'合作共赢'
          }
        },
        {
          path: '/addPrescriptionContact',
          name: 'addPrescriptionContact',
          component: addPrescriptionContact,
          meta:{
            title:'患者信息',
            // requireAuth: true,
          }
        },
        {
          path: '/Contact',
          name: 'Contact',
          component: Contact,
          meta:{
            title:'患者',
            requireAuth: true,
          }
        },
        {
          path: '/prescriptionInfo',
          name: 'prescriptionInfo',
          component: prescriptionInfo,
          meta:{
            title:'症状信息',
            requireAuth: true,
          }
        },
        {
          path: '/prescriptionResult',
          name: 'prescriptionResult',
          component: prescriptionResult,
          meta:{
            title:'处方信息',
            requireAuth: true,
          }
        },
        {
          path: '/Prescription',
          name: 'Prescription',
          component: Prescription,
          meta:{
            title:'支付成功',
            requireAuth: true,
          }
        },
        {
          path: '/addServiceContact',
          name: 'addServiceContact',
          component: addServiceContact,
          meta:{
            first:true,
            requireAuth: true,
          }
        },
        {
          path: '/serviceResult',
          name: 'serviceResult',
          component: serviceResult,
          meta:{
            requireAuth: true,
            clear:false
          }
        },
        {
          path: '/prescriptionImage',
          name: 'prescriptionImage',
          component: prescriptionImage,
          meta:{
            title:'处方笺',
            requireAuth: true,
          }
        },
        {
          path: '/protocol',
          name: 'protocol',
          component: protocol,
          meta:{
            title:'隐私协议',
            requireAuth: false,
          }
        },
        {
          path: '/order',
          name: 'order',
          component: order,
          meta:{
            title:'订单',
            requireAuth: true,
            keepAlive: true,
          }
        },
        {
          path: '/apply',
          name: 'apply',
          component: apply,
          meta:{
            title:'申请医生',
            requireAuth: true,
          }
        },
        {
          path: '/applying',
          name: 'applying',
          component: applying,
          meta:{
            title:'申请医生',
            requireAuth: true,
          }
        },
        {
          path: '/userInfo',
          name: 'userInfo',
          component: userInfo,
          meta:{
            title:'医生信息',
            requireAuth: true,
          }
        },
        {
          path: '/fulfillmentConfirm',
          name: 'fulfillmentConfirm',
          component: fulfillmentConfirm,
          meta:{
            title:'配送订单',
            requireAuth: true,
          }
        },
        {
          path: '/fulfillmentOrder',
          name: 'fulfillmentOrder',
          component: fulfillmentOrder,
          meta:{
            title:'订单详情',
            requireAuth: true,
          }
        },
        {
          path: '/wjtpay',
          name: 'wjtpay',
          component: wjtpay,
          meta:{
            title:'收银台',
            requireAuth: true,
          }
        },
        {
          path: '/address',
          name: 'address',
          component: address,
          meta:{
            title:'我的地址',
            requireAuth: true,
          }
        },
        {
          path: '/points',
          name: 'points',
          component: MyPoints,
          meta:{
            title:'我的积分',
            requireAuth: true,
          }
        },
        {
          path: '/AboutUsers',
          name: 'AboutUsers',
          component: AboutUsers,
          meta:{
            first:true,
          }
        },
        {
          path: '/GeneralPrescriptionInfo',
          name: 'GeneralPrescriptionInfo',
          component:GeneralPrescriptionInfo,
          meta:{
            first:true,
          }
        },
        {
          path: '/GeneralPrescriptionResult',
          name: 'GeneralPrescriptionResult',
          component:GeneralPrescriptionResult,
          meta:{
            first:true,
          }
        },
        {
          path: '/GeneralPrescription',
          name: 'GeneralPrescription',
          component:GeneralPrescription,
          meta:{
            first:true,
          }
        },
        {
          path: '/handmadePrescription',
          name: 'handmadePrescription',
          component: handmadePrescription,
          meta:{
            title:'自拟组方',
            requireAuth: true,
          }
        },
        {
          path: '/handmadePrescriptionConfirm',
          name: 'handmadePrescriptionConfirm',
          component: handmadePrescriptionConfirm,
          meta:{
            title:'自拟组方详情',
            requireAuth: true,
          }
        },
        {
          path: '/handmadePrescriptionDetails',
          name: 'handmadePrescriptionDetails',
          component: handmadePrescriptionDetails,
          meta:{
            title:'自拟组方确认',
            requireAuth: true,
          }
        },
        {
          path: '/CUSTOMIZEDPrescription',
          name: 'CUSTOMIZEDPrescription',
          component:CUSTOMIZEDPrescription,
          meta:{
            first:true,
          }
        },
        {
          path: '/CUSTOMIZEDfulfillmentConfirm',
          name: 'CUSTOMIZEDfulfillmentConfirm',
          component:CUSTOMIZEDfulfillmentConfirm,
          meta:{
            first:true,
          }
        },
        {
          path: '/CUSTOMIZEDfulfillmentOrder',
          name: 'CUSTOMIZEDfulfillmentOrder',
          component:CUSTOMIZEDfulfillmentOrder,
          meta:{
            first:true,
          }
        },
        {
          path: '/commonAddPrescriptionContact',
          name: 'commonAddPrescriptionContact',
          component:commonAddPrescriptionContact,
          meta:{
            first:true,
          }
        },
        {
          path: '/commonPrescriptionInfo',
          name: 'commonPrescriptionInfo',
          component:commonPrescriptionInfo,
          meta:{
            first:true,
          }
        },
        {
          path: '/commonHandmadePrescription',
          name: 'commonHandmadePrescription',
          component:commonHandmadePrescription,
          meta:{
            first:true,
          }
        },
        {
          path: '/commonHandmadePrescriptionConfirm',
          name: 'commonHandmadePrescriptionConfirm',
          component:commonHandmadePrescriptionConfirm,
          meta:{
            first:true,
          }
        },
        {
          path: '/commonHandmadePrescriptionDetails',
          name: 'commonHandmadePrescriptionDetails',
          component:commonHandmadePrescriptionDetails,
          meta:{
            first:true,
          }
        },
        {
          path: '/commonPrescriptionImage',
          name: 'commonPrescriptionImage',
          component:commonPrescriptionImage,
          meta:{
            first:true,
          }
        },
        {
          path: '/commonFulfillmentConfirm',
          name: 'commonFulfillmentConfirm',
          component:commonFulfillmentConfirm,
          meta:{
            first:true,
          }
        },
        {
          path: '/chaoweiContact',
          name: 'chaoweiContact',
          component: chaoweiAddPrescriptionContact,
          meta:{
            title:'超微饮品-患者信息',
            requireAuth: true,
          }
        },
        {
          path: '/chaoweiPrescriptionInfo',
          name: 'chaoweiPrescriptionInfo',
          component: chaoweiPrescriptionInfo,
          meta:{
            title:'超微饮品-症状信息',
            requireAuth: true,
          }
        },
        {
          path: '/chaoweiPrescriptionResult',
          name: 'chaoweiPrescriptionResult',
          component: chaoweiPrescriptionResult,
          meta:{
            title:'超微饮品-处方信息确认',
            requireAuth: true,
          }
        },
        {
          path: '/chaoweiPrescription',
          name: 'chaoweiPrescription',
          component: ChaoWeiPrescription,
          meta:{
            title:'超微饮品处方',
            requireAuth: true,
          }
        },
        {
          path: '/chaoweiPrescriptionImage',
          name: 'chaoweiPrescriptionImage',
          component: chaoweiPrescriptionImage,
          meta:{
            title:'超微饮品处方笺',
            requireAuth: true,
          }
        },
      ]
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login,
      meta: {
        title:'登录'
      }
    },
    {
      path: '/Signup',
      name: 'Signup',
      component: Signup,
      meta: {
        title:'注册'
      }
    },
    {
      path: '/ResetPassword',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: {
        title:'忘记密码'
      }
    },
    {
      path: '/SetPassword',
      name: 'SetPassword',
      component: SetPassword,
      meta: {
        title:'设置密码'
      }
    },
    {
      path: '/GetCode',
      name: 'GetCode',
      component: GetCode,
      meta: {
        keepAlive: true,
        title:'获取验证码'
      }
    },
    {
      path: '/Invite',
      name: 'Invite',
      component: Invite,
      meta: {
        title:'邀请'
      }
    },
    {
      path: '/Bind',
      name: 'Bind',
      component: Bind,
      meta: {
        title:'绑定'
      }
    }
  ]
})


router.beforeEach((to, from, next) => {
  // 获取到前面打过标签的元素，将其scrollTop属性设置为0
  document.documentElement.scrollTop = 0
  // 滚动条可能出现在HTML元素上而不是body上，确保兼容性，同时将HTML和body中scrollTop属性设置为0
  document.body.scrollTop = 0
  // 调用继续路由跳转
  next()
})


export default router


var originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
